module.exports = __webpack_public_path__ + "img/170824.cb1f0bd0.png";